import React, { useEffect, useState } from "react";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import ComplimentryService from "../../../Services/QRCodeServices/ComplimentryService/ComplimentryService";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { Link } from "react-router-dom";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const ComplimentryOrderwise = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [dateRange, setDateRange] = useState([null, null]);
  const [filterText, setFilterText] = useState("");
  const [productId, setProductId] = useState(null);

  const fetchData = async (
    page = 1,
    pageSize = pagination.pageSize,
    searchText = filterText,
    productIdParam = productId
  ) => {
    setLoading(true);
    try {
      const response = await ComplimentryService.getOrderwise({
        page,
        pageSize,
        startDate: dateRange[0]
          ? dateRange[0].toISOString().split("T")[0]
          : null,
        endDate: dateRange[1] ? dateRange[1].toISOString().split("T")[0] : null,
        productId: productIdParam || null,
        search: searchText || "",
      });

      if (response) {
        setAllData(response);
        setPagination({
          currentPage: response.currentPage,
          pageSize: response.pageSize,
          totalPages: response.totalPages,
          totalData: response.totalData,
        });
      } else {
        setAllData([]);
        setPagination((prev) => ({ ...prev, totalData: 0 }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // fetch when filters change
  useEffect(() => {
    fetchData(1);
  }, [dateRange, filterText, productId]);

  // columns
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "75px",
    },
    {
      name: "Order Ref",
      selector: (row) => row.orderRef,
      sortable: true,
    },
    {
      name: "Items",
      cell: (row) => (
        <div>
          {row.items.map((item, i) => (
            <div key={i}>
              <Link to={`/menu-item/detail/${item.productId}`}>
                {item.productName}
              </Link>{" "}
            </div>
          ))}
        </div>
      ),
      sortable: false,
    },
    {
      name: "Item Qty",
      cell: (row) => (
        <div>
          {row.items.map((item, i) => (
            <div key={i}>{item.quantity}</div>
          ))}
        </div>
      ),
      sortable: false,
      width: "6rem",
    },
    {
      name: "Item value",
      cell: (row) => (
        <div>
          {row.items.map((item, i) => (
            <div key={i}>{item.complimentryValue}</div>
          ))}
        </div>
      ),
      sortable: false,
      right: true,
    },

    {
      name: "Order Amt",
      selector: (row) => row.totalOrderAmount,
      sortable: true,
      right: true,
    },
    {
      name: "Comp Total",
      selector: (row) => row.totalComplimentryValue,
      sortable: true,
      right: true,
    },
  ];

  return (
    <>
      <Card>
        <CardBody>
          {/* Filters */}
          <Row className="mb-3">
            <Col md={4}>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
            </Col>
          </Row>

          {/* Table */}
          <CustomDataTable
            responsive
            striped
            pagination
            paginationServer
            paginationTotalRows={pagination.totalData}
            paginationDefaultPage={pagination.currentPage}
            onChangePage={(page) => fetchData(page)}
            onChangeRowsPerPage={(newPageSize) => fetchData(1, newPageSize)}
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={{
              headCells: {
                style: {
                  fontSize: "0.93rem",
                  fontWeight: 610,
                },
              },
              rows: {
                style: {
                  fontSize: "0.9rem",
                },
              },
            }}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={allData}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default ComplimentryOrderwise;
